var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFastForward = function SvgFastForward(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M11.96 12.456c-.089.251-.254.488-.495.685l-7.945 6.5c-.767.628-1.395.33-1.395-.661V5.02c0-.991.628-1.289 1.395-.661l7.945 6.5c.24.197.406.434.495.686V5.02c0-.991.628-1.289 1.395-.661l7.945 6.5c.767.628.767 1.655 0 2.282l-7.945 6.5c-.767.628-1.395.33-1.395-.661v-6.524Z"
  })));
};
export default SvgFastForward;